import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { LoginService } from 'app/components/login/login.service';
import { HttpHeaders } from '@angular/common/http';
import { CONSTANTS } from 'environments/common';
import { NgbActiveModal, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ModalRecoveryPasswordComponent } from 'app/components/modal-recovery-password/modal-recovery-password.component';
import { UsersService } from 'app/components/users/users.service';
import { ModalRedirectSdaComponent } from 'app/components/modal-redirect-sda/modal-redirect-sda.component';
import { UtilsService } from "../utils/utils.service";
import { TranslateService } from '@ngx-translate/core';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';
import { AnalyticsService } from 'app/components/analytics/analytics.service';



@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrls: ['./modal-login.component.css']
})
export class ModalLoginComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  currentImage: string = '';
  errorMessage: string = '';
  okMessage: string = '';
  eventData: object = {};

  user: object = {
    username: '',
    password: ''
  };
  typePassword: string = 'password';

  constructor(private sessionService: SessionService, private loginService: LoginService, private ngbActiveModal: NgbActiveModal,
    private modalService: NgbModal, private usersService: UsersService, private utilsService: UtilsService,
    private translateService: TranslateService, private catalogueUserService: CatalogueUserService, private analyticsService: AnalyticsService) { }

  cancel(){
    this.ngbActiveModal.dismiss();
  };

  togglePassword(){
    this.typePassword = this.typePassword === 'password' ? 'text' : 'password';
  }

  passwordRecovery(){
    const modalRef = this.modalService.open(ModalRecoveryPasswordComponent);
    this.ngbActiveModal.close();
  };



  getToken(getTokenIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';
    this.okMessage = '';

    this.loginService.getToken(getTokenIn)
      .subscribe((token: object) => {
        let data = {"token": token, "user":getTokenIn}
        this.getTokenOk(data);
      },
        error => {
          this.getTokenError(error);
        });

  }

  getTokenOk(data) {
    this.loader.count--;
    this.setToken(data.token);

    this.getUser(data);

  }

  getTokenError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    if (error.status == '401') {
      alertData.alertMessage = 'LOGIN_MODAL.401';
      this.analyticsService.sendLogin('KO', 'Password not match.');
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getTokenBtn() {

    let getTokenIn = {
      accountId: this.eventData['accountId'],
      username: this.user['username'],
      password: this.user['password']
    }

    this.getToken(getTokenIn);

  }

  setToken(token) {
    let nameStorageToken = `token_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageToken, token, true);
    let nameStorageUsername = `username_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageUsername, this.user['username'], true);
  }

  getUser(getUserIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.getUser(getUserIn)
      .subscribe((data: object) => {
        this.getUserOk(data);
      },
        error => {
          this.getUserError(error);
        });

  }

  getUserOk(data) {

    this.loader.count--;

    if (this.checkUserProfile(data)) {

      this.setUserProfile(data);

      let checkLoggedUserIn = {
        eventName: this.eventData['eventName']
      };

      this.checkLoggedUser(checkLoggedUserIn);

    } else {

      let checkAttendeeIn = {
        eventsCode: [this.eventData['sapCode']]
      };

      this.checkAttendee(checkAttendeeIn);

    }

  }

  getUserError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.analyticsService.sendLogin('KO', alertData.alertMessage);

  }

  checkUserProfile(profile) {

    let validUser = false;

    for (let i = 0; i < profile.authorities.length; i++) {
      if (CONSTANTS.VALID_ROLES.indexOf(profile.authorities[i].name) !== -1) {
        validUser = true;
      }
    }

    return validUser;

  }

  setUserProfile(profile) {
    let nameStorageProfile = `profile_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageProfile, profile, true);
  }

  checkLoggedUser(checkLoggedUserIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.checkLoggedUser(checkLoggedUserIn)
      .subscribe((data: object) => {
        this.checkLoggedUserOk(data);
      },
        error => {
          this.checkLoggedUserError(error);
        });

  }

  checkLoggedUserOk(data) {

    this.loader.count--;
    this.catalogueUserService.setData(data);
    this.ngbActiveModal.close();
    this.analyticsService.sendLogin('OK', '');
    //this.reloadPage();
  }

  reloadPage() {
    //window.location.reload();
  }

  checkLoggedUserError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.analyticsService.sendLogin('KO', alertData.alertMessage);

  }

  checkAttendee(checkAttendeeIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.checkAttendee(checkAttendeeIn)
      .subscribe((data: object) => {
        this.checkAttendeeOk(data);
      },
        error => {
          this.checkAttendeeError(error);
        });

  }

  checkAttendeeOk(data) {

    this.loader.count--;
    if (!data.ticketMinimalDTOS) {
      const modalRef = this.modalService.open(ModalRedirectSdaComponent);
      this.ngbActiveModal.close();
      this.loginService.removeSessionVariables();
      this.analyticsService.sendLogin('KO', 'Attendee has no ticket.');
    } else {
       this.analyticsService.sendLogin('OK', '');
    }
  }

  checkAttendeeError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.analyticsService.sendLogin('KO', alertData.alertMessage);

  }

  sendOneTimePassword(sendOneTimePasswordIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';
    this.okMessage = '';

    this.usersService.sendOneTimePassword(sendOneTimePasswordIn)
      .subscribe((data: object) => {
        this.sendOneTimePasswordOk(data);
      },
        error => {
          this.sendOneTimePasswordError(error);
        });

  }

  sendOneTimePasswordOk(data) {

    this.loader.count--;
    if (data.result) {
      this.okMessage = 'LOGIN_MODAL.ONE_TIME_PASSWORD_OK';
    } else {
      this.alertMessage = 'LOGIN_MODAL.ONE_TIME_PASSWORD_KO';

    }

  }

  sendOneTimePasswordError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  sendOneTimePasswordBtn(){

    let sendOneTimePasswordIn = {
      accountId: this.eventData['accountId'],
      username: this.user['username'],
      language: this.utilsService.mapLanguageCode(this.translateService.currentLang)
    }

    this.sendOneTimePassword(sendOneTimePasswordIn);

  };




  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
  }

}
